module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/scotch@2x_53b9de.jpg";